import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import "../Jobseekers/Catalog/catalogs.css";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Select from 'react-select';
import { faAngleRight, faUserPlus, faChevronLeft, faChevronRight, faFilter, faFilterCircleXmark, faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { saveAs } from 'file-saver';
// import Papa from 'papaparse';
// import { faCircleDown } from '@fortawesome/free-regular-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
function CommunityMember() {
    const navigate = useNavigate();
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isGridVisible, setGridVisible] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    useEffect(() => {
        const fetchMembers = async () => {
        setLoading(true);
        try {
            const response = await apiService.getRequest('/community-members');
            if(response.success === true){
                setMembers(response.data);
            }
        } catch (error) {
            console.error('Error fetching jobseeker status list:', error);
        }finally{
            setLoading(false);
        }
        };
        fetchMembers();
    }, []);
    
    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };

    const [filters, setFilters] = useState([{ operator: 'And', column: 'userName', operatorType: 'contains', value: '' }]);


    const combineOptions = [
        { value: 'And', label: 'And' },
        { value: 'Or', label: 'Or' },
    ];
    const rows = members.map((datas) => ({
        id: datas.id,
        formatid: datas.formatted_id,
        userName: datas.full_name,
        city:datas.living_city && datas.living_city.name,
        state:datas.living_state && datas.living_state.name,
        country:datas.living_country && datas.living_country.name,
        contactPhone: datas.phone_number,
        contactEmail: datas.email,
        refereName:datas.referred_by && datas.referred_by.full_name,
        refereId:datas.referred_by && datas.referred_by.formatted_id,
        // status: datas.status_details.label,
    }));

    const handleFilterChange = (index, field, value) => {
        const newFilters = [...filters];
        // Reset value if changing the column type
        if (field === 'column') {
            newFilters[index].value = newFilters[index].column === 'date' ? [null, null] : '';
        }
        newFilters[index][field] = value;
        setFilters(newFilters);
    };

    const addFilter = () => {
        setFilters([...filters, { operator: 'And', column: 'userName', operatorType: 'contains', value: '' }]);
    };

    const removeFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };

    const operatorOptions = [
        { value: 'contains', label: 'contains' },
        { value: 'doesNotContain', label: 'does not contain' },
        { value: 'startsWith', label: 'starts with' },
        { value: 'endsWith', label: 'ends with' },
        { value: 'is', label: 'is' },
        { value: 'isNot', label: 'is not' },
        { value: 'isEmpty', label: 'is empty' },
        { value: 'isNotEmpty', label: 'is not empty' },
    ];

    const getOperatorOptions = (column) => {
        // if (column === 'cityStatus') {
        //     return [
        //         { value: 'contains', label: 'contains' },
        //         { value: 'doesNotContain', label: 'does not contain' },
        //         { value: 'startsWith', label: 'starts with' },
        //         { value: 'endsWith', label: 'ends with' },
        //         { value: 'is', label: 'is' },
        //         { value: 'isNot', label: 'is not' },
        //         { value: 'isOneOf', label: 'is one of' },
        //         { value: 'isNotOneOf', label: 'is not one of' },
        //         { value: 'isEmpty', label: 'is empty' },
        //         { value: 'isNotEmpty', label: 'is not empty' },
        //     ];
        // }else if (column === 'eadcardapplieddate') {
        //     return [
        //         { value: 'on', label: 'On' },
        //         { value: 'notOn', label: 'Not On' },
        //         { value: 'before', label: 'Before' },
        //         { value: 'atOrBefore', label: 'At Or Before' },
        //         { value: 'after', label: 'After' },
        //         { value: 'atOrAfter', label: 'At Or After' },
        //         { value: 'between', label: 'Between' },
        //         { value: 'isEmpty', label: 'is empty' },
        //         { value: 'isNotEmpty', label: 'is not empty' },
        //     ];
        // }
        return operatorOptions; // Default options
    };
    
    const filteredRows = rows.filter((row) =>
        filters.reduce((acc, filter, index) => {
            const rowValue = row[filter.column] ? row[filter.column].toString() : '';
            let matches = false;
            if (filter.column ) {
                // General filter logic for other columns
                switch (filter.operatorType) {
                    case 'contains':
                        matches = rowValue.toLowerCase().includes(filter.value.toLowerCase());
                        break;
                    case 'doesNotContain':
                        matches = !rowValue.toLowerCase().includes(filter.value.toLowerCase());
                        break;
                    case 'startsWith':
                        matches = rowValue.toLowerCase().startsWith(filter.value.toLowerCase());
                        break;
                    case 'endsWith':
                        matches = rowValue.toLowerCase().endsWith(filter.value.toLowerCase());
                    break;
                    case 'is':
                        matches = rowValue.toLowerCase() === filter.value.toLowerCase();
                        break;
                    case 'isNot':
                        matches = rowValue.toLowerCase() !== filter.value.toLowerCase();
                        break;
                    case 'isEmpty':
                        matches = rowValue === '';
                        break;
                    case 'isNotEmpty':
                        matches = rowValue !== '';
                        break;
                    default:
                        matches = false;
                }
            }
    
            return index === 0 ? matches : (filter.operator === 'And' ? acc && matches : acc || matches);
        }, true)
    );
    useEffect(() => {
        setCurrentPage(0);
    }, [filters]);
    const paginatedRows = filteredRows.slice(currentPage * pageSize, currentPage * pageSize + pageSize);

    // const downloadCSV = () => {
    //     const csvData = filteredRows.map(row => ({
    //         'Jobseeker No': row.formatid,
    //         'User Name': row.userName,
    //         'Citizenship Status': row.cityStatus,
    //         'Email': row.contactEmail,
    //         'Phone Number': row.contactPhone,
    //         'State': row.state,
    //         'City': row.city,
    //         'Referrer Name': row.refereName,
    //     }));
    //     const csv = Papa.unparse(csvData); // Parse the data into CSV
    //     const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    //     saveAs(blob, 'filtered_jobseekers.csv'); // Trigger file download
    // };
    const [show, setShow] = useState(false);
    const [selectedMemberId, setSelectedMemberId] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = (memberId) => {
        setSelectedMemberId(memberId);
        setShow(true);
    };

    const handleDelete = async () => {  
        try {
            const response = await apiService.deleteRequest(`/community-members/${selectedMemberId}`); // Call DELETE API
            if(response && response.success){
                setMembers(members.filter(member => member.id !== selectedMemberId)); // Remove deleted member from state
                toast(response.message || 'Community Member deleted successfully!');
            }else{
                toast(response.message);
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            console.log(err,"Failed to delete member");
        }
        handleClose();
    };
    const columns = [
        {
            field: 'formatid',
            headerName: 'ID',
            width: 250,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <Link to={`/community-member/view/${params.row.formatid}`} className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.formatid}</Link>
                </div>
            ),
            filterable: true,
        },
        {
            field: 'refereName',
            headerName: 'Referred By',
            width: 250,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.refereName}</span>
                </div>
            ),
            filterable: true,
        },
        {
            field: 'userName',
            headerName: 'Name',
            width: 250,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.userName}</span>
                </div>
            ),
            filterable: true,
        },
        {
            field: 'contactPhone',
            headerName: 'Primary phone',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <Box className="linklistview h-100 d-flex align-items-center">
                    <Typography><span><a href={`tel:${params.row.contactPhone}`} target="_blank" rel="noopener noreferrer">{params.row.contactPhone}</a></span></Typography>
                </Box>
            )
        },
        {
            field: 'contactEmail',
            headerName: 'Primary Email',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <Box className="linklistview h-100 d-flex align-items-center">
                    <Typography><span><a href={`mailto:${params.row.contactEmail}`} target="_blank" rel="noopener noreferrer">{params.row.contactEmail}</a></span></Typography>
                </Box>
            )
        },
        
        {
            field: 'city',
            headerName: 'Living City',
            width: 200,
            filterable: true,
        },
        {
            field: 'state',
            headerName: 'Living State',
            width: 200,
            filterable: true,
        },
        {
            field: 'country',
            headerName: 'Living Country',
            width: 200,
            filterable: true,
        },
        ...(permissionstest && ( permissionstest.manage_community_editor || permissionstest.manage_community_remover)
            ? [
            {
            field: 'action',
            headerName: 'Action',
            width: 200,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <Grid size={{ xs: 12 }} container alignItems="center" justifyContent="flex-start" className="gap-md-3 h-100 gap-2">
                    {permissionstest && permissionstest.manage_community_editor &&
                        <button className='editbtnroot' onClick={() => navigate(`/community-member/edit/${params.row.formatid}`)}>
                            <FontAwesomeIcon icon={faPenToSquare} />
                        </button>
                    }
                    {permissionstest && permissionstest.manage_community_remover &&
                        <button className='trashbtnroot' onClick={() => handleShow(params.row.id)}>
                            <FontAwesomeIcon icon={faTrashCan} />
                        </button>
                    }
                </Grid>
            ),
        },
        
    ] : []
    ),
    ];

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        refereName: true,
    });
    const columnOptions = [
        { label: "Name", value: "userName" },
        { label: "Referred By", value: "refereName" },
        { label: "ID", value: "formatid" },
        { label: "Primary Email", value: "contactEmail" },
        { label: "Primary Phone", value: "contactPhone" },
        { label: "Living City", value: "city" },
        { label: "Living State", value: "state" },
        { label: "Living Country", value: "country" },
    ];
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Community Member</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Community Member</span>
                    </Grid>
                </Grid>
                <Grid size={{md:12,xs:12}} container justifyContent="flex-end" alignItems="center" className="my-4">
                    {permissionstest && permissionstest.manage_community_creator &&
                        <Grid size={{md:12,xs:12}} justifyContent="flex-end" alignItems="center" container className="memberser_heads">
                            <button className="small_adsbtn" onClick={()=>navigate("/community-member/add")}>
                                <FontAwesomeIcon icon={faUserPlus} />
                            </button>
                        </Grid>
                    }
                    <Grid size={{xs:12}} container className="mt-5">
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                            {isGridVisible && (
                            <Box sx={{ mb: 2 }} className="my-4">
                                {filters.map((filter, index) => (
                                    <Box key={index} sx={{ display: 'flex', alignItems: 'end', mb: 1 }}>
                                        {index > 0 && (
                                            <select
                                                label="Combine"
                                                value={filter.operator}
                                                onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                                                sx={{ mr: 1, minWidth: 80 }}
                                            >
                                                {combineOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                ))}
                                            </select>
                                        )}
                                        <Grid container flexDirection="column">
                                            <label>Column</label>
                                            <Select
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                options={columnOptions}
                                                value={columnOptions.find(option => option.value === filter.column)}
                                                onChange={(selectedOption) => handleFilterChange(index, 'column', selectedOption ? selectedOption.value : '')}
                                                isSearchable
                                                placeholder="Select Data to filter"
                                                styles={{
                                                    container: (provided) => ({ ...provided, minWidth: 200, marginRight: '8px' }),
                                                }}
                                            />
                                        </Grid>
                                        <Grid container flexDirection="column">
                                            <label>Operator</label>
                                            <Select
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                options={getOperatorOptions(filter.column).map(option => ({
                                                    label: option.label,
                                                    value: option.value
                                                }))}
                                                value={getOperatorOptions(filter.column).find(option => option.value === filter.operatorType)}
                                                onChange={(selectedOption) => handleFilterChange(index, "operatorType", selectedOption ? selectedOption.value : "")}
                                                isSearchable
                                                placeholder="Select Operator"
                                                styles={{ container: (provided) => ({ ...provided, minWidth: 120 }) }}
                                            />
                                        </Grid>
                                        <Grid container flexDirection="column" className="mx-2">
                                            {filter.operatorType === "isNotEmpty" || filter.operatorType === "isEmpty" ? "" :<>
                                                {filter.operatorType !== "between" &&
                                                <label>Value</label>}
                                                <input
                                                    className='value_inputfilter'
                                                    placeholder='Value'
                                                    label="Value"
                                                    value={filter.value}
                                                    onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                /></>}
                                        </Grid>
                                        <button className='filterremovebtn' onClick={() => removeFilter(index)}>Remove</button>
                                    </Box>
                                ))}
                                <button className='filteraddbtn' onClick={addFilter}>Add Filter</button>
                            </Box>)}
                            <Grid size={{xs:12}} container justifyContent="space-between">
                                <button className='show_filterbtn' onClick={toggleGrid}>
                                    {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                                </button>
                                {/* <button className='download_csvbtndatatable' onClick={downloadCSV}>Download CSV<FontAwesomeIcon className='ps-2' icon={faCircleDown} /></button> */}
                            </Grid>
                            <DataGrid
                                style={{minHeight:"200px"}}
                                rows={paginatedRows}
                                columns={columns}
                                pageSize={pageSize}
                                disableSelectionOnClick
                                components={{ Toolbar: GridToolbar }}
                                columnVisibilityModel={columnVisibilityModel}
                                onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
                            />
                            <div className='d-flex flex-column my-3 pagination_datagrid'>
                                <Grid size={{xs:12}} container justifyContent="space-between">
                                    <div className='d-flex justify-content-end align-items-center'>
                                        <label className='me-2'>Showing records <b>{filteredRows.length === 0 ? 0 : currentPage * pageSize + 1}–{Math.min((currentPage + 1) * pageSize, filteredRows.length)}</b> out of <b>{filteredRows.length.toLocaleString()}</b></label>
                                    </div>
                                    <div className='d-flex justify-content-end align-items-center'>
                                        <label>No. of Rows</label>
                                        <select
                                            label="Rows per page"
                                            value={pageSize}
                                            onChange={(e) => {setPageSize(Number(e.target.value)); setCurrentPage(0);}}
                                            sx={{ mr: 2 }}
                                        >
                                            {[5, 10, 20, 50].map((size) => (
                                                <option key={size} value={size}>{size}</option>
                                            ))}
                                        </select>
                                    </div>
                                </Grid>

                                <div className="d-flex justify-content-center my-3">
                                    <button
                                        className='nexter_btns'
                                        variant="contained"
                                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                                        disabled={currentPage === 0}
                                    >
                                        <FontAwesomeIcon icon={faChevronLeft} />
                                    </button>

                                    {/* Page number buttons */}
                                    {filteredRows.length > 0 && (
                                        <div className="d-flex align-items-center mx-2">
                                            {(() => {
                                            const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
                                            const pages = [];

                                            const start = Math.max(1, currentPage + 1 - 2);
                                            const end = Math.min(totalPages - 1, currentPage + 1 + 2);

                                            // Always show first page
                                            pages.push(
                                                <button
                                                key={1}
                                                className={`page-btn ${currentPage === 0 ? 'active' : ''}`}
                                                onClick={() => setCurrentPage(0)}
                                                >
                                                1
                                                </button>
                                            );

                                            if (start > 2) {
                                                pages.push(<span key="start-ellipsis" className="px-1">...</span>);
                                            }

                                            for (let i = start; i <= end; i++) {
                                                if (i !== 1 && i !== totalPages) {
                                                pages.push(
                                                    <button
                                                    key={i}
                                                    className={`page-btn ${currentPage === i - 1 ? 'active' : ''}`}
                                                    onClick={() => setCurrentPage(i - 1)}
                                                    >
                                                    {i}
                                                    </button>
                                                );
                                                }
                                            }

                                            if (end < totalPages - 1) {
                                                pages.push(<span key="end-ellipsis" className="px-1">...</span>);
                                            }

                                            if (totalPages > 1) {
                                                pages.push(
                                                <button
                                                    key={totalPages}
                                                    className={`page-btn ${currentPage === totalPages - 1 ? 'active' : ''}`}
                                                    onClick={() => setCurrentPage(totalPages - 1)}
                                                >
                                                    {totalPages}
                                                </button>
                                                );
                                            }

                                            return pages;
                                            })()}
                                        </div>
                                    )}

                                    <button
                                        className='nexter_btns'
                                        variant="contained"
                                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(filteredRows.length / pageSize) - 1))}
                                        disabled={currentPage >= Math.ceil(filteredRows.length / pageSize) - 1}
                                    >
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </button>
                                </div>
                            </div>
                        </Box>
                    </>}
                    </Grid>
                </Grid>
            </Grid>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this Member?</Modal.Body>
                <Modal.Footer>
                    <button className='modal_cancel' onClick={handleClose}>
                        Cancel
                    </button>
                    <button className='modal_delete' onClick={handleDelete}>
                        Delete
                    </button>   
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default CommunityMember
